import { Builder, withChildren } from '@builder.io/react';
import React from 'react';

import {
  FontWeight,
  Text as TextComponent,
  TextProps,
} from '../../storyblocks-design-system/components/atoms/Text/Text';
import { createFontConfigInputs } from '../configurations/fontConfig';

interface TextBuilderProps extends TextProps {
  text: string;
  fontColor?: string;
  fontWeight?: FontWeight;
  htmlElement?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  resetCSS?: boolean;
}

const Text = withChildren(
  ({
    text,
    fontSize,
    fontFamily,
    fontColor,
    fontWeight,
    htmlElement,
    resetCSS,
  }: TextBuilderProps) => {
    const ElementTag = (htmlElement || 'span') as keyof JSX.IntrinsicElements;

    return (
      <TextComponent
        fontSize={fontSize}
        fontFamily={fontFamily}
        fontWeight={fontWeight}
        asChild
        className={resetCSS ? 'm-0 p-0' : ''}
      >
        <ElementTag style={{ color: fontColor }}>{text}</ElementTag>
      </TextComponent>
    );
  }
);

Builder.registerComponent(Text, {
  name: 'Text SB',
  inputs: [
    {
      name: 'htmlElement',
      type: 'string',
      friendlyName: 'HTML Element',
      defaultValue: 'span',
      enum: ['span', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
      helperText: 'Choose which HTML element to render',
    },
    {
      name: 'text',
      type: 'string',
      defaultValue: 'Text goes here',
      required: true,
    },
    ...createFontConfigInputs(),
    {
      name: 'fontColor',
      type: 'color',
      defaultValue: '#000000',
      helperText: 'Text color',
    },
    {
      name: 'resetCSS',
      friendlyName: 'Reset CSS',
      type: 'boolean',
      defaultValue: true,
      helperText: 'Remove default margin and padding',
    },
  ],
});
